module.exports = __webpack_public_path__ + "img/logo.7b8bddd8.svg";